<template>
  <site-footer />
</template>

<script>
import SiteFooter from '@/components/home/SiteFooter.vue'

export default {
  name: 'ScholarFooter',
  components: { SiteFooter }
}
</script>
